import script from "./TableDataAdministrative.vue?vue&type=script&setup=true&lang=js"
export * from "./TableDataAdministrative.vue?vue&type=script&setup=true&lang=js"

import "./TableDataAdministrative.vue?vue&type=style&index=0&id=d68d300e&lang=css"

const __exports__ = script;

export default __exports__